// Data YYYY-MM-DD nel fuso dell'utente (non UTC).
// Segnalazione 00ac5d1b (16/10/2026): le pagine Ads costruivano il periodo a mezzanotte locale
// e lo convertivano con toISOString() (UTC): in Italia "oggi" diventava "ieri", quindi la riga
// di oggi di ad_daily_stats non veniva mai letta e ogni periodo partiva un giorno prima.

export function toLocalYmd(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/**
 * Testo "Dati aggiornati alle HH:MM" dal last_synced_at piu' recente delle righe statistiche.
 * Oggi: solo l'ora; altri giorni: data e ora. null se non c'e' alcuna data valida.
 */
export function lastSyncLabel(
  rows: Array<{ last_synced_at?: string | null }>,
  now: Date = new Date(),
): string | null {
  let max = 0;
  for (const r of rows) {
    const t = r.last_synced_at ? Date.parse(r.last_synced_at) : NaN;
    if (!Number.isNaN(t) && t > max) max = t;
  }
  if (!max) return null;
  const d = new Date(max);
  const hhmm = `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
  if (toLocalYmd(d) === toLocalYmd(now)) return `Dati aggiornati oggi alle ${hhmm}`;
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  return `Dati aggiornati il ${dd}/${mm} alle ${hhmm}`;
}
